/* eslint-disable max-len */
import React from 'react';

export function CountdownTimer(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 25">
      <mask id="a" x="0" y="0" maskUnits="userSpaceOnUse" style={{ maskType: 'alpha' }}>
        <path fill="currentColor" d="M.504.5h24v24h-24z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill="currentColor"
          d="M9.504 3.5v-2h6v2h-6Zm2 11h2v-6h-2v6Zm1 8a8.646 8.646 0 0 1-3.487-.712 9.192 9.192 0 0 1-2.863-1.938 9.193 9.193 0 0 1-1.937-2.863 8.646 8.646 0 0 1-.713-3.487c0-1.233.238-2.396.713-3.488A9.193 9.193 0 0 1 6.154 7.15a9.193 9.193 0 0 1 2.863-1.938 8.646 8.646 0 0 1 3.487-.712 8.92 8.92 0 0 1 2.975.5c.95.333 1.842.817 2.675 1.45l1.4-1.4 1.4 1.4-1.4 1.4a9.72 9.72 0 0 1 1.45 2.675c.333.95.5 1.942.5 2.975a8.646 8.646 0 0 1-.713 3.488 9.192 9.192 0 0 1-1.937 2.862 9.191 9.191 0 0 1-2.862 1.938 8.645 8.645 0 0 1-3.488.712Zm0-2c1.933 0 3.583-.683 4.95-2.05 1.367-1.367 2.05-3.017 2.05-4.95 0-1.933-.683-3.583-2.05-4.95-1.367-1.367-3.017-2.05-4.95-2.05-1.933 0-3.583.683-4.95 2.05-1.367 1.367-2.05 3.017-2.05 4.95 0 1.933.683 3.583 2.05 4.95 1.367 1.367 3.017 2.05 4.95 2.05Z"
        />
      </g>
    </svg>
  );
}
